module.exports = __webpack_public_path__ + "img/pic_3.561825c1.png";